import type { IUserData } from '../types/user';

export const defaultUserData: IUserData = {
  achievements: [],
  demographics: {
    ageRange: undefined,
    gender: undefined,
    occupation: undefined,
  },
  email: '',
  firebaseUserId: '',
  preferences: {
    notificationSchedule: undefined,
    friendsList: [],
  },
  profile: {},
  startingPage: '/',
};
